module.exports = __webpack_public_path__ + "static/media/user-male-new.ed151787.svg";